export const FormSectionsIMSimpleInspection = [
	'none',
	''
];

export const UiSectionsIMSimpleInspection = [
	'none'
];

export enum RulesBaseIMSimpleInspection {
	NONE = 1
}
